var Header;
(function (Header) {
    const $devBar = document.querySelector('.region-meta--frontend');
    const $header = document.querySelector('#header');
    const $heroCarousel = document.querySelector('.hero-carousel');
    if ($header) {
        function setHeaderTop() {
            if ($devBar) {
                $header.classList.add('dev-mode');
            }
        }
        function headerFixed() {
            const $height = $header.offsetHeight;
            if (window.innerWidth <= 991.98 && window.pageYOffset > 0) {
                $header.classList.add('fixed-header');
            }
            else if (window.pageYOffset >= $height) {
                $header.classList.add('fixed-header');
            }
            else {
                $header.classList.remove('fixed-header');
            }
        }
        function transparent() {
            if ($heroCarousel) {
                $header.classList.add('is-transparent');
            }
        }
        function openSubMenu() {
            const $primaryMenu = $header.querySelector('.menu-level-0');
            if ($primaryMenu) {
                const $primaryMenus = $primaryMenu.querySelectorAll('.menu-item');
                if ($primaryMenus.length) {
                    $primaryMenus.forEach(($menu) => {
                        const $icons = $menu.querySelectorAll('.icn');
                        $icons.forEach(($icon) => {
                            $icon.addEventListener('click', () => {
                                const $menuContent = $menu.querySelector('.menu_link_content');
                                if ($menuContent.classList.contains('is-open')) {
                                    $menuContent.classList.remove('is-open');
                                }
                                else {
                                    $menuContent.classList.add('is-open');
                                }
                            });
                        });
                    });
                }
            }
            clear();
        }
        function clear() {
            const $closeMenu = $header.querySelector('#main-menu-toggle');
            $closeMenu.addEventListener('click', () => {
                if ($closeMenu.checked == false) {
                    const $primaryMenu = $header.querySelector('.menu-level-0');
                    const $primaryMenus = $primaryMenu.querySelectorAll('.menu-item');
                    $primaryMenus.forEach(($menu) => {
                        const $menuContent = $menu.querySelector('.menu_link_content');
                        if ($menuContent) {
                            $menuContent.classList.remove('is-open');
                        }
                    });
                }
            });
        }
        function init() {
            setHeaderTop();
            // transparent();
            window.onscroll = function () {
                headerFixed();
            };
            openSubMenu();
        }
        init();
    }
})(Header || (Header = {}));
